var Handlebars = require("../../../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"dd-doc-nav-merge-pdf\" class=\"dropdown-menu\">\n    <div id=\"pdfComboDL-nav\" class=\"mi\" title=\"Download\">\n        <span class=\"dd-icon icon-download\"></span>\n        Download\n    </div>\n    <div id=\"pdfComboLink-nav\" class=\"mi\" title=\"Open in new window\">\n        <span class=\"dd-icon icon-link-ext\"></span>\n        New Window\n    </div>\n</div>\n";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/nav/navBar/comboPdf/template.hbs
 ** module id = 700
 ** module chunks = 0
 **/